import { api } from '../services/api';

interface DNSRecord {
  id: string;
  name: string;
  type: string;
  value: string;
  ttl: number;
}

interface Zone {
  id: string;
  providerId: string;
  name: string;
}

export const zoneOperations = {
  updateRecord: async (zone: Zone, recordId: string, updateData: Partial<DNSRecord>) => {
    await api.put(
      `/api/v1/dns/records/providers/${zone.providerId}/zones/${zone.id}/${recordId}`,
      updateData,
    );
  },

  deleteRecord: async (zone: Zone, recordId: string) => {
    await api.delete(
      `/api/v1/dns/records/providers/${zone.providerId}/zones/${zone.id}/${recordId}`,
    );
  },

  createRecord: async (zone: Zone, recordData: Omit<DNSRecord, 'id'>) => {
    await api.post(
      `/api/v1/dns/records/providers/${zone.providerId}/zones/${zone.id}`,
      recordData,
    );
  },

  bulkDelete: async (zone: Zone, recordIds: string[]) => {
    const response = await api.post(
      `/api/v1/dns/records/providers/${zone.providerId}/zones/${zone.id}/bulk`,
      {
        operation: 'delete',
        records: recordIds.map((id) => ({ id })),
      },
    );
    return response.data;
  },

  bulkUpdateTTL: async (zone: Zone, recordIds: string[], ttl: number) => {
    const response = await api.post(
      `/api/v1/dns/records/providers/${zone.providerId}/zones/${zone.id}/bulk`,
      {
        operation: 'update',
        records: recordIds.map((id) => ({ id, ttl })),
      },
    );
    return response.data;
  },

  addZone: async (newZone: { name: string; providerId: string; type: string }) => {
    await api.post('/api/zones', newZone);
  },

  deleteZone: async (id: string) => {
    await api.delete(`/api/zones/${id}`);
  },
};